<template>
  <v-container
    class="px-8"
    >
    <v-row class="border mt-6">
      <v-col 
        class="px-4"
        cols="6">
        <span 
          class="text-h5 font-weight-medium">
          {{ $t('property.headers.fixes')}}
        </span>
      </v-col>

      <v-col 
        class="pr-4"
        cols="6">
        <div
          class="d-flex flex-row align-center justify-end"
          >
          <v-btn
            @click="modal = true"
            color="primary">
            {{ $t('action.add_fix') }}
          </v-btn>
        </div>
      </v-col>

      <v-dialog
        width="800px"
        v-model="modal"
        >
        <v-card>
          <v-card-title>
            {{ $t('action.add_fix') }}
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="primary"
              @click="modal = false"
              >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-form
              v-model="valid"
              lazy-validation
              ref="form"
              >
              <v-text-field
                filled
                v-model="fix.name"
                label="Nombre"
                placeholder="Reparación de techo"
                :rules="rules"
                hint="*Obligatorio"
                persistent-hint
                >
              </v-text-field>

              <v-select
                v-model="referral"
                :items="referrals"
                item-text="name"
                return-object
                filled
                label="Pagado por"
                hint="*Obligatorio" 
                persistent-hint
                :rules="rules"
                >
              </v-select>

              <div
                class="d-flex justify-space-between"
                >
                <v-text-field
                  filled
                  v-model="fix.amount"
                  label="Costo"
                  placeholder="2500"
                  class="mr-2"
                  suffix="ARS"
                  :rules="rules"
                  hint="*Obligatorio"
                  persistent-hint
                  >
                </v-text-field>

                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fix.fixedAt"
                      class="ml-2"
                      label="Fecha del arreglo"
                      append-icon="mdi-calendar-blank"
                      readonly
                      filled
                      v-bind="attrs"
                      v-on="on"
                      ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fix.fixedAt"
                    @input="endMenu = false"
                    ></v-date-picker>
                </v-menu>
              </div>

              <v-textarea
                filled
                v-model="fix.description"
                label="Descripción"
                placeholder="Lorem ipsum dolorem..."
                persistent-hint
                >
                </v-textarea>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              @click="createFix"
              >
              Crear
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-col
        cols="12"
        class="pt-0 px-4"
        v-if="fixes"
        v-for="fix in fixes"
        >
        <v-card
          class="rounded-lg"
          >
          <v-card-text
            class="text-subtitle-1 black--text py-2 d-flex flex-row justify-space-between align-center"
            >
            <div>
              {{ fix.name }}
            </div>
            <div>
              <v-btn
                icon
                color="primary"
                class="ml-3"
                >
                <v-icon>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Fixes } from '@/graphql/queries/property'
import { CreateFix } from '@/graphql/mutations/properties'

export default {
  data () {
    return {
      rules: [
        v => !!v || '*Obligatorio'
      ],
      fix: {
        name: null,
        description: null,
        propertyId: null,
        contractId: null,
        state: null,
        fixedAt: null,
        amount: 0,
        payerId: null,
        payerType: 'User',
        paymentsAttributes: [
          {
            referralId: null,
            referralType: null,
            concept: 'Reparaciones',
            state: 'paid',
            period: "0",
            dueDate: (new Date()),
            amount: 0,
            subAccountId: null,
            contractId: null,
          }
        ] 
      },
      referral: {
        name: null,
        referralType: null,
        referralId: null
      },
      payer: {
        name: null,
        referralType: null,
        referralId: null
      },
      modal: false,
      menu: false,
      valid: true,
      fixes: [],
    }
  },

  props: {
    property: {
      required: true,
      type: Object
    }
  },

  mounted () {
    this.fetchFixes()

    this.fix.propertyId = this.property.id
    this.fix.contractId = this.property.activeContract.id
    this.fix.payerId = this.property.owner[0].id
    this.fix.paymentsAttributes[0].subAccountId = this.property.fixesSubAccountId
    this.fix.paymentsAttributes[0].contractId = (this.property.activeContract || {}).id

    this.fix.paymentsAttributes.push({
      referralId: this.property.owner[0].id,
      referralType: 'User',
      concept: 'Reparaciones',
      state: 'pending',
      period: "0",
      dueDate: (new Date()),
      amount: null,
      subAccountId: this.property.fixesSubAccountId,
      contractId: (this.property.activeContract || {}).id
    })
  },

  watch: {
    referral: {
      handler (val) {
        this.fix.paymentsAttributes[0].referralType = val.referralType
        this.fix.paymentsAttributes[0].referralId = val.referralId
      },
    },

    payer: {
      handler (val) {
        this.fix.payerType = val.referralType
        this.fix.payerId = val.referralId

        this.fix.paymentsAttributes[1].referralType = val.referralType
        this.fix.paymentsAttributes[1].referralId = val.referralId
      },
    },

    'fix.amount' (val) {
      this.fix.paymentsAttributes.forEach( (p, i) => {
        if (i) {
          p.amount = Math.abs(val)
        } else {
          p.amount = Math.abs(val) * -1
        }
      })
    }
  },

  computed: {
    referrals () {
      if (this.property.activeTenant) {
        return [
          { name: 'Locatario', referralId: this.property.activeTenant.id, referralType: 'User' },
          { name: 'Locador', referralId: this.property.owner[0].id, referralType: 'User' },
          { name: 'Inmobiliaria', referralId: this.property.agencyId, referralType: 'Agency' },
        ]
      } else {
        return [
          { name: 'Inmobiliaria', referralId: this.property.agencyId, referralType: 'Agency' },
          { name: 'Locador', referralId: this.property.owner[0].id, referralType: 'User' },
        ]
      }
    }
  },

  methods: {
    fetchFixes () {
      this.$apollo.query({
        query: Fixes,
        variables: {
          propertyId: this.property.id
        }
      }).then( res => {
        this.fixes = res.data.fixes
      })
    },

    createFix () {
      if (this.valid) this.valid = this.$refs.form.validate()

      if (this.valid) {
        this.$apollo.mutate({
          mutation: CreateFix,
          variables: {
            input: {
              attributes: this.fix
            }
          }
        }).then(res => {
          this.fetchFixes()
          this.fix = {}
          this.modal = false
          if (this.$refs.form) this.$refs.form.resetValidation()
        })
      }
    }
  }
}
</script>
